import { useGetProductsByNameLazyQuery } from 'domains/merchandising/api'

export const useGetProductsByNameLazy = () => {
  const [getProductsByName, { data, error, loading }] = useGetProductsByNameLazyQuery()

  let products = []

  if (data?.catalogRetailerProductSearch?.edges?.length) {
    products = data.catalogRetailerProductSearch.edges.map(({ node }) => node)
  }

  return {
    getProductsByName,
    products,
    result: data?.catalogRetailerProductSearch,
    success: Boolean(data),
    loading: loading,
    error: error,
  }
}
